function isNullOrUndefined (value) {
  return value === null || value === undefined
}

export { isNullOrUndefined }



// WEBPACK FOOTER //
// ./src/utils/isNullOrUndefined.js